<template>
    <div class="main">

        <div class="banner">
            <div class="banner-left">
                <div class="title">{{$t('contribute.theme1')}}<br>{{$t('contribute.theme2')}}</div>
                
                
                <div style="margin-top: 25px; margin-right: 115px;">
                    
                    <div class="content">{{$t('contribute.advantage')}}</div>
                    <div class="content">{{$t('contribute.advantage2')}}</div>
                   
                </div>

            </div>

            <div class="banner-right">
                <img :src="require('../assets/contribute/RWApicture.png')" alt="" />
            </div>
        </div>
        <Board></Board>
        <div class="container3">

       <div class="RWA_accelerate">
       
        <div class="RWAacctitle2">{{$t('accelerate.title2')}}</div>
        <div class="RWA_picture" :style="{ backgroundImage: mainImageStyle }">
    <img src="@/assets/RWA/contentbackgound.png" class="bottom-frame" alt="文字介绍底框">
    <div class="word_title">{{ $t(currentWordKey + '.title') }}</div>
    <div class="word_content">{{ $t(currentWordKey + '.content') }}</div>
</div>
        <div class="picture_line">
          <div class="RWA_picture1" 
               @click="changeMainImage('t1.png')"
               :style="{ backgroundImage: activeImage === 't1.png' ? 
                       `url(${require('@/assets/RWA/t2.png')})` : 
                       `url(${require('@/assets/RWA/t3.png')})` }"></div>
          <div class="RWA_picture2" 
               @click="changeMainImage('g1.png')"
               :style="{ backgroundImage: activeImage === 'g1.png' ? 
                       `url(${require('@/assets/RWA/g2.png')})` : 
                       `url(${require('@/assets/RWA/g3.png')})` }"></div>
          <div class="RWA_picture3" 
               @click="changeMainImage('s1.png')"
               :style="{ backgroundImage: activeImage === 's1.png' ? 
                       `url(${require('@/assets/RWA/s2.png')})` : 
                       `url(${require('@/assets/RWA/s3.png')})` }"></div>
          <div class="RWA_picture4" 
               @click="changeMainImage('q1.png')"
               :style="{ backgroundImage: activeImage === 'q1.png' ? 
                       `url(${require('@/assets/RWA/q2.png')})` : 
                       `url(${require('@/assets/RWA/q3.png')})` }"></div>
        </div>
        
       </div>
       
       <div class="RWA_past">
        <div class="past_title">{{$t('past.title')}}</div>
        <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin:0 auto;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>
        <div class="past_line">
          <div class="arrow-left" @click="slidePast(-1)">
            <img :src="require('../assets/RWA/left.png')" alt="左箭头">
          </div>
          <div class="past-viewport">
            <div class="past-track" :style="{ transform: `translateX(${pastOffset}px)`, transition: isPastSliding ? 'transform 0.5s ease' : 'none' }">
              <div
                class="past-item"
                v-for="(url, idx) in visiblePast4"
                :key="idx"
                :style="{ backgroundImage: url ? 'url(' + url + ')' : '' }"
              ></div>
            </div>
          </div>
          <div class="arrow-right" @click="slidePast(1)">
            <img :src="require('../assets/RWA/right.png')" alt="右箭头">
          </div>
        </div>

        </div>  



        <div class="RWA_introduce">
        <div class="introduce_title">{{$t('introduce.title')}}</div>
        <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin:0 auto;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>
        <div class="introduce">
        
        
        <div class="module-section1">
                <div class="module-content1">
                    <div class="module-left1">
                       <div class="introduce_title2">{{$t('introduce.title1')}}</div>
                        <div class="introduce_content2">{{$t('introduce.content1')}}</div>
                        <div class="module-button">
                            {{ $t("develop.redbook.btn") }}
                        </div>
                      
                    </div>
                    <div class="module-right1">
                        <img src="../assets/RWA/xpicture.png" alt=""  />
                    </div>
                </div>
            </div>

            <!-- 分隔虚线 -->
            <div class="dashed-line"></div>

        <div class="module-section">
                <div class="module-content">
                    <div class="module-left">
                       <div class="introduce_title2">{{$t('introduce.title2')}}</div>
                        <div class="introduce_content2">{{$t('introduce.content2')}}</div>              
                        <div class="module-button">
                            {{ $t("develop.redbook.btn") }}
                        </div>
                    </div>
                    <div class="module-right">
                        <img src="../assets/RWA/ypicture.png" alt="" />
                    </div>
                </div>
            </div>
             
        </div>
          <!--参考Devekop-->
           
        </div> 
       </div>
        

        

    </div>
</template>

<script>
import Board from '@/components/Board.vue'
import { stylePhotosList } from '@/api'
export default {
    name: 'Contribute',
    components: { Board },
    data() {
        return {
            ecologySystems: [
                {
                    img: require('../assets/contribute/ecologySystem/crosschain.png'),
                    title: this.$t('contribute.module1.product[8].title'),
                    titleStyle: 'rgb(110 93 84)',
                    describe: this.$t('contribute.module1.product[8].describe'),
                },
                {
                    img: require('../assets/contribute/ecologySystem/webphone.png'),
                    title: this.$t('contribute.module1.product[9].title'),
                    titleStyle: 'rgb(32 35 54)',
                    describe: this.$t('contribute.module1.product[9].describe'),
                },
                {
                    img: require('../assets/contribute/ecologySystem/deepseek.png'),
                    title: this.$t('contribute.module1.product[10].title'),
                    titleStyle: 'rgb(73 99 252)',
                    describe: this.$t('contribute.module1.product[10].describe'),
                },
                {
                    img: require('../assets/contribute/ecologySystem/kimi.png'),
                    title: this.$t('contribute.module1.product[11].title'),
                    titleStyle: 'rgb(6 6 5)',
                    describe: this.$t('contribute.module1.product[11].describe'),
                },
             
            ],
            publicProducts: [
                {
                    img: require('../assets/contribute/publicProduct/sentinel.png'),
                    title: this.$t('contribute.module2.product[0].title'),
                    titleStyle: 'rgb(130, 184, 255)',
                    describe: this.$t('contribute.module2.product[0].describe'),
                },
            ],
            mainImageUrl: 't1.png',
            activeImage: 't1.png', // 当前选中的图片
            currentWordKey: 'word',
            pastPhotoUrls: [],
            pastStartIndex: 0,
            pastCarouselTimer: null,
            isPastSliding: false,
            pastOffset: 0,
            pastStep: 289,
            pastSlideDuration: 500,
            pastDirection: 1
        }
    },
    mounted() {
        this.loadStylePhotos(1)
    },
    destroyed() { this.stopPastCarousel() },
    computed: {
        mainImageStyle() {
            return `url(${require('@/assets/RWA/' + this.mainImageUrl.split('/').pop())})`;
        },
        visiblePast4() {
            const urls = this.pastPhotoUrls || [];
            if (!urls.length) return ['', '', '', '', ''];
            const len = urls.length;
            const start = this.pastStartIndex % len;
            const get = i => urls[(i + len) % len] || '';
            if (this.isPastSliding && this.pastDirection < 0) {
                return [get(start - 1), get(start), get(start + 1), get(start + 2), get(start + 3)];
            }
            return [get(start), get(start + 1), get(start + 2), get(start + 3), get(start + 4)];
        }
    },
    methods: {
        changeMainImage(imageUrl) {
            this.mainImageUrl = imageUrl;
            this.activeImage = imageUrl;
            const map = {
                't1.png': 'word',
                'g1.png': 'word2',
                's1.png': 'word3',
                'q1.png': 'word4'
            };
            this.currentWordKey = map[imageUrl] || 'word';
        },
        async loadStylePhotos(category = 1) {
            try {
                const res = await stylePhotosList(category);
                const data = res?.data ?? res;
                const urls = data?.result?.photoUrl || data?.data?.photoUrl || data?.photoUrl || [];
                this.pastPhotoUrls = (urls || []).map(u => this.normalizePhotoUrl(String(u || ''))).filter(Boolean);
                this.pastStartIndex = 0;
                if (this.pastPhotoUrls.length) {
                    this.startPastCarousel();
                } else {
                    this.stopPastCarousel();
                }
            } catch (e) {
                console.error('loadStylePhotos failed:', e);
                this.pastPhotoUrls = [];
            }
        },
        slidePast(direction) {
            const len = this.pastPhotoUrls.length;
            if (!len) return;
            if (this.isPastSliding) return;
            this.pastDirection = direction;
            this.isPastSliding = true;
            this.pastOffset = direction > 0 ? -this.pastStep : this.pastStep;
            setTimeout(() => {
                this.isPastSliding = false;
                const step = direction > 0 ? 1 : -1;
                this.pastStartIndex = (this.pastStartIndex + step + len) % len;
                this.pastOffset = 0;
            }, this.pastSlideDuration);
        },
        startPastCarousel() {
            this.stopPastCarousel();
            const len = this.pastPhotoUrls.length;
            if (!len) return;
            this.pastCarouselTimer = setInterval(() => {
                this.slidePast(1);
            }, 3000);
        },
        stopPastCarousel() {
            if (this.pastCarouselTimer) {
                clearInterval(this.pastCarouselTimer);
                this.pastCarouselTimer = null;
            }
        },
        normalizePhotoUrl(url) {
            const cleaned = String(url || '').trim().replace(/^[`'"]+|[`'"]+$/g, '').replace(/\s+/g, '');
            if (!cleaned) return '';
            if (/^https?:\/\//i.test(cleaned)) return cleaned;
            const base = process.env.VUE_APP_NEWS_API_BASE || 'http://192.168.56.109:9016';
            const prefix = base.endsWith('/') ? base.slice(0, -1) : base;
            const rel = cleaned.startsWith('/') ? cleaned : `/${cleaned}`;
            return `${prefix}${rel}`;
        }
    }
}
</script>


<style lang="scss" scoped>
.main {
    padding-top: 50px;
   width: 100%;
    
    .banner {
       min-width: 1200px;
       height: 576px; 
      
       padding-top: 50px;
       background-image: url("../assets/home/RWAbackground.png");
       background-repeat: no-repeat;
       background-position: center;
       background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
       position: relative;
        box-sizing: border-box;
       /* 固定整个页面画布为 1920，居中 */
       width: 100%;
     
       margin: 0 auto;

          .banner-left {
            flex: 1 1 auto;
            max-width: 1000px;
            text-align: left;
            z-index: 2;
            position: relative;
            left: 220px;
            top:-20px;
            /* 标题样式 */
            .title {
                color: #ffffff;
                font-size: 70px;
                font-weight: 700;
                line-height: 1.4;
                margin-bottom: 10px;
                font-family: 'Arial', sans-serif;
                max-width: 1600px;
            }
           
            /* 内容文本样式 */
            .content {
                font-family: 'Arial', sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #aaa9a9a2;
                max-width: 100%;
                line-height: 1.4;
            }
        }

        /* 横幅右侧图片区域 */
        .banner-right {
            top:-10px;
            left:-100px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10;
            position: relative;
            
            img {
                width: 100%;
                height: auto;
                scale: 0.75;
                
            }
        }
    }
    .container3 {
       background-image: url('../assets/background/background2.png');
       background-size: cover;
       background-position: center;
       background-repeat: no-repeat;
       /* 原高度保留，如需完全不变可改成像素值 */
       
       width: 100%;
       margin: 0 auto;
      
       position: relative;
       
        min-width: 1200px;
       
    .RWA_accelerate {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative ;
        top:100px;
        left:45px;
         margin: 0 auto;
        
    /*display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative ;
        top:140px;
        margin-bottom: 60px;
       margin-top: 50px;*/
    .RWAactitle {
       color: #ffffff;
                font-size: 62px;
                font-weight: 500;
                line-height: 1.5;
                margin-bottom: 0px;
                font-family: 'Arial', sans-serif;
                width: 750px;
                top: -30px;
                position: relative;
                margin-bottom: 60px;
                left: -240px;
    }
    .RWAacccontent {
        color: #8b8b8b;
        font-size: 21px;
        font-weight: 200;
        line-height: 1.2;
        margin-bottom: 10px;
        font-family: '微软雅黑';
        width: 1235px;
        top: -30px;
        position: relative;
        margin-bottom: 80px;
        left: 0;
    }
    .RWAacctitle2 {
      color: #ffffff;
                font-size: 40px;
                font-weight: 500;
                line-height: 1.5;
                margin-bottom: 0px;
                font-family: 'Arial', sans-serif;
                width: 750px;
                top: -30px;
                position: relative;
                margin: 0;
                left: -240px;
    }
    }
    .RWA_picture {
        background-image: url('../assets/RWA/t1.png');
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;

        top: 0px;
        left: -25px;
        width: 1246px;
        height: 815px;
        margin-bottom: 10px;
        
        .bottom-frame {
            position: absolute;
            bottom: -10px; /* 向下移动50px */
            left: 0;
            width: 100%;
            height: auto;
            z-index: 0;
        }
        .word_title {
            position: absolute;
            top: 560px;
            left: 20px;
            font-size: 34px;
            font-weight: 500;
            line-height: 1.2;
            margin-bottom: 0px;
            font-family: "微软雅黑";
            color: #ffffff;
        }
        .word_content {
            position: absolute;
            top: 640px;
            left: 20px;
            font-size: 21px;
            font-weight: 200;
            line-height: 1.6;
            margin-bottom: 0px;
            font-family: "微软雅黑";
            color: #ffffff;
            width: 1200px;
            
        }
    }
    
    .picture_line {
        display: flex;
        gap: 9px;
        left:-25px;
        position: relative;
    }
    
    .RWA_picture1 {
        width: 305px;
        height: 213px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/t2.png');
        background-size: cover;
        background-position: center;
    }
    
    .RWA_picture2 {
        width: 305px;
        height: 213px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/g2.png');
        background-size: cover;
        background-position: center;
    }
    
    .RWA_picture3 {
        width: 305px;
        height: 213px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/g2.png');
        background-size: cover;
        background-position: center;
    }
    
    .RWA_picture4 {
        width: 305px;
        height: 213px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/q2.png');
        background-size: cover;
        background-position: center;
    }
    .RWA_past {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative ;
        top:140px;
        margin-bottom: 60px;
       margin-top: 50px;
        .past_title {
              color: #ffffff;
        font-size: 60px;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 0px;
        font-family: "微软雅黑";
        margin-top: 30px;
        }
    }
    .past_line {
        display: flex;
        align-items: center;
        left:25px;
        position: relative;
        margin-top: 80px;
    }
    .past-viewport {
        overflow: hidden;
        width: 1147px;
    }
    .past-track {
        display: flex;
        gap: 9px;
        will-change: transform;
    }
    .past-item {
        width: 280px;
        height: 187px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-size: cover;
        background-position: center;
    }
    
    .arrow-left {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
    }
    
    .arrow-right {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
    }
    
    .arrow-left img, .arrow-right img {
        max-width: 100%;
        height: auto;
    }
    
    .past_picture1 {
        width: 280px;
        height: 187px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/1.jpg');
        background-size: cover;
        background-position: center;
    }
    
    .past_picture2 {
        width: 280px;
        height: 187px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/2.jpg');
        background-size: cover;
        background-position: center;
    }
    
    .past_picture3 {
        width: 280px;
        height: 187px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/3.jpg');
        background-size: cover;
        background-position: center;
    }
    
    .past_picture4 {
        width: 280px;
        height: 187px;
        flex-shrink: 0;
        background-color: #ffffff;
        background-image: url('../assets/RWA/4.jpg');
        background-size: cover;
        background-position: center;
    }
    .RWA_introduce {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative ;
        top:140px;
        margin-bottom: -100px; /* 进一步增大负外边距值 */
        overflow-x: hidden;
        
        .introduce_title {
              color: #ffffff;
        font-size: 60px;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 0px;
        font-family: "微软雅黑";
        margin-top: 30px;
        }
    }

     .module-section {
            margin-bottom: 80px;
            
            .module-content {
                display: flex;
                align-items: center;
                gap: 110px;
  .module-right {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                top: -60px;
                left: -80px;

                img {
                    
                    height: auto;
                    border-radius: 12px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
                    cursor: pointer;
                    transition: transform 0.3s ease;


                }
            }




                .module-left {
                    flex: 1;
                    position: relative;
                    top: -100px;
                    left: 250px;

                    .introduce_title2 {
                        font-family: '微软雅黑';
                        font-size: 34px;
                        font-weight: 530;
                        color: #ffffff;
                        margin-bottom: 30px;
                        line-height: 1.2;
                        letter-spacing: 2px; 
                    }

                    .introduce_content2 {
                        font-family: '微软雅黑';
                        width: 700px;
                        font-size: 20px;
                        color: #979595e3;
                        ;
                        line-height: 1.6;   
                        margin-bottom: 20px;
                      
                    }

                  

                    .module-button {

                        display: inline-block;
                        font-family: '微软雅黑';
                        background: linear-gradient(135deg, #ff3b30, #c91e2b);
                        color: #ffffff;
                        padding: 11px 30px;
                        border-radius: 23px;
                        font-size: 22px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        border: none;
                        outline: none;
                    }


                }
            }

          
        }
        .dashed-line {
        width: 100%;
        height: 1px;
        border-top: 2px dashed #666;
        margin: -180px 0 40px 0;
    }

    .module-section1 {
            margin-bottom: 0px;
           
            .module-content1 {
                display: flex;
                align-items: center;
                gap: 110px;
                  .module-right1 {
                flex: 1;
                order: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                left: 70px;
                top: -80px;
               

                img {
                    max-width: 100%;
                    height: auto;
                    border-radius: 12px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
                    cursor: pointer;
                    transition: transform 0.3s ease;
                    


                }
            }
                .module-left1 {
                    flex: 1;
                    order: 2;
                    position: relative;
                    left: -240px;
                    top: -20px;

                    .introduce_title2 {
                        font-family: '微软雅黑';
                        font-size: 34px;
                        font-weight: 530;
                        color: #ffffff;
                        margin-bottom: 30px;
                        line-height: 1.2;
                        letter-spacing: 2px; 
                    }

                    .introduce_content2 {
                        font-family: '微软雅黑';
                        width: 800px;
                        font-size: 20px;
                        color: #979595e3;
                        ;
                        line-height: 1.6;
                        margin-bottom: 40px;
                    }

                   

                    .module-button {   

                        display: inline-block;
                        font-family: '微软雅黑';
                        background: linear-gradient(135deg, #ff3b30, #c91e2b);
                        color: #ffffff;
                        padding: 11px 30px;
                        border-radius: 23px;
                        font-size: 22px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        border: none;
                        outline: none;
                    }


                }
            }

          
        }

}
}

</style>


